import { DeleteMeetingCommand } from "@aws-sdk/client-chime-sdk-meetings";
import { getChimeClient } from "./get-chime-client";
import ToasterWithMessage from "../../components/toaster";

const { error: errorToast } = ToasterWithMessage();

export const deleteChimeMeeting = async (MeetingId: string): Promise<void> => {
  console.log('inside the deletechime meeting=======>');
  try {
    const chimeClient = await getChimeClient();

    const command = new DeleteMeetingCommand({ MeetingId });

    await chimeClient.send(command);
    console.log(`[Log] Meeting ${MeetingId} deleted successfully.`);
  } catch (error: any) {
    if(error?.message?.includes('Meeting') && error?.message?.includes('not found')) {
      errorToast("Meeting not found");
    }else{
      errorToast(error.message);
    }
    console.error("[Log] Error deleting meeting:", error);
  }
};
